import { render, staticRenderFns } from "./deepSeek.vue?vue&type=template&id=b81f37d8&scoped=true"
import script from "./deepSeek.vue?vue&type=script&lang=js"
export * from "./deepSeek.vue?vue&type=script&lang=js"
import style0 from "./deepSeek.vue?vue&type=style&index=0&id=b81f37d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81f37d8",
  null
  
)

export default component.exports